import { provideHttpClient } from '@angular/common/http';
import { APP_INITIALIZER, ApplicationConfig } from '@angular/core';
import { MAT_ICON_DEFAULT_OPTIONS } from '@angular/material/icon';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';

import { appRoutes } from './app.routes';
import { EnvironmentResolver } from './core/environment-resolver';

const initializeEnvironment = (environmentResolver: EnvironmentResolver) => async (): Promise<void> => {
    await environmentResolver.setEnvironment();
};

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(appRoutes),
        provideAnimations(),
        provideHttpClient(),
        {
            provide: APP_INITIALIZER,
            useFactory: initializeEnvironment,
            multi: true,
            deps: [EnvironmentResolver]
        },
        { provide: MAT_ICON_DEFAULT_OPTIONS, useValue: { fontSet: 'material-symbols-rounded' } }
    ]
};
